// @flow

import ApiObject from './ApiObject';

export default class Address extends ApiObject {

  street: string = '';

  city: string = '';

  postCode: string = '';

  country: string = ''; // a two letters identifier like 'FR'
}



// WEBPACK FOOTER //
// ./sdk/scripts/entities/Address.js